module.exports = __webpack_public_path__ + "assets/img/09-s.39e41b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/09-s.jpg
// module id = rsN+
// module chunks = 0